module.exports = __webpack_public_path__ + "static/media/popup-bgm.3b3fb93f.wav";